var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoommateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.1 36.6",
    style: {
      enableBackground: "new 0 0 63.1 36.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,1.2H6.9c-3,0-5.5,2.5-5.5,5.5l0,23.1c0,3.1,2.5,5.5,5.5,5.5h49.4c3,0,5.5-2.5,5.5-5.5V6.7 C61.7,3.6,59.2,1.2,56.2,1.2z M58.6,29.4c0,1.5-1.2,2.7-2.7,2.7H7.2c-1.5,0-2.7-1.2-2.7-2.7V7c0-1.5,1.2-2.7,2.7-2.7h48.6 c1.5,0,2.7,1.2,2.7,2.7V29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,17.6h7.5c1.5,0,2.7-1.2,2.7-2.7V7.6c0-0.4-0.4-0.8-0.8-0.8h-9c-0.7,0-1.3,0.6-1.3,1.3v8.6 C7.3,17.3,7.7,17.6,8.2,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,6.9H21v8c0,2.9-2.4,5.3-5.3,5.3H8.1c-0.5,0-0.8,0.4-0.8,0.8v7.2c0,0.7,0.6,1.3,1.3,1.3h22.9 c0.7,0,1.3-0.6,1.3-1.3V8.2C32.8,7.4,32.2,6.9,31.5,6.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoommateIcon);
export default __webpack_public_path__ + "static/media/roommate-icon.453881b4788bb92de133414fb7f0dc74.svg";
export { ForwardRef as ReactComponent };